import React from 'react';

import { Box } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';

const CustomTabPanel = (props) => {
    const { children, selectedTab, sx, value, ...other } = props;

    return (
        <Box
            aria-labelledby={`tab-${value}`}
            hidden={value !== selectedTab}
            id={`tabpanel-${value}`}
            role="tabpanel"
            sx={sx}
            {...other}
        >
            {value === selectedTab && children}
        </Box>
    );
};

CustomTabPanel.propTypes = {
    children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    selectedTab: PropTypes.string,
    sx: PropTypes.object,
    value: PropTypes.string,
};

export default CustomTabPanel;
